// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"534db44c","24":"4b2eb130","70":"c271bc72","109":"7dc1bec0","339":"4f41b935","378":"a2acf340","457":"342288f0","559":"758f5a49","578":"ea9ed522","607":"09c70179","618":"c5926374","623":"5ca66c78","689":"59c92198","708":"74b7b55f","721":"3d4a9814"}[chunkId] + ".chunk.js";
};